import React from 'react'
import styled from 'styled-components'
import Barcode from 'react-barcode'
import Typography from '@ntuctech/devex-tangram/Typography'

const Holder = styled.div`
  font-size: 1rem;
  padding-bottom: 1.25rem;
  text-align: center;
  .name {
    color: #1557bf;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }
  .member-type {
    margin-bottom: 0.5rem;
  }
`

const BarcodeSection = ({ name, cardNumber, date, memberType }) => {
  return (
    <Holder>
      <div className="barcode">
        <Barcode value={cardNumber} fontSize={14} format="EAN13" />
      </div>
      <Typography variant="h3" className="name">
        {name}
      </Typography>
      <Typography className="member-type" variant="h3">
        {memberType}
      </Typography>
      <Typography variant="body2">Expiry Date: {date}</Typography>
    </Holder>
  )
}

export default BarcodeSection
